import { FETCH_ALL_SURVEYS, FETCH_ALL_SURVEYS_REQUEST, FETCH_ALL_SURVEYS_ERROR } from '../constants/actionTypes'
import * as api from '../api'

export const getAllSurvey = (SurveyID, SurveyYear) => async (dispatch) => {
    try {
        dispatch({ type: FETCH_ALL_SURVEYS_REQUEST });
        const { data } = await api.getSurveyQuestions(SurveyID, SurveyYear);
        dispatch({ type: FETCH_ALL_SURVEYS, payload: data ?? [] })
    } catch (error) {
        dispatch({
            type: FETCH_ALL_SURVEYS_ERROR,
            payload: error.message || "Something went wrong"
        });
        //toastifyMessage("Something went wrong...!", undefined, "error");
    }
}